import React from 'react';
import PropTypes from 'prop-types';

import FareListContainerMobile from '../FareListContainerMobile';

const FareTableContainerMobile = (props) => <FareListContainerMobile {...props} />;

FareTableContainerMobile.componentName = 'FareTableContainerMobile';

FareTableContainerMobile.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

FareTableContainerMobile.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'fareTable'
  }
};

export default FareTableContainerMobile;
